import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AssignOrderToSurveyorBusy, OfferOrder, OfferOrderSuccess, ResetDisposition, SetDisposition } from '../action/disposition.action';
import { DispositionStateModel } from '../interface/disposition.interface';

const initialDispositionState = {
    timestamp: '',
    isAssigning: false,
    orderId: null,
    creatorId: 0,

    isAcceptanceAllowed: true,
    acceptanceTimeout: null,
    acceptanceTimeoutDate: new Date(),
    acceptanceTimeoutTime: getDateWithOffsetMinutes(15),
    termOfAcceptance: null,
    mustBeProcessed: true,
    processingDuration: null,
    processingDueDay: null,
    processingDurationDate: new Date(),
    processingDurationTime: getDateWithOffsetHours(72),
    invalidDueDate: false,
};

function getDateWithOffsetMinutes(minutesOffset: number): Date {
    const now = new Date();
    now.setMinutes(now.getMinutes() + minutesOffset);
    return now;
}

function getDateWithOffsetHours(hoursOffset: number): Date {
    const now = new Date();
    now.setHours(now.getHours() + hoursOffset);
    return now;
}

@State<DispositionStateModel>({
    name: 'disposition',
    defaults: initialDispositionState,
})
@Injectable()
export class DispositionState {
    @Selector()
    static getIsAssigning(state: DispositionStateModel) {
        return state.isAssigning;
    }

    @Selector()
    static getDisposition(state: DispositionStateModel) {
        return state;
    }

    @Action(SetDisposition)
    setDisposition(ctx: StateContext<DispositionStateModel>, action: SetDisposition) {
        ctx.setState(action.dispositionState);
    }

    @Action(ResetDisposition)
    resetDisposition(ctx: StateContext<DispositionStateModel>) {
        ctx.setState(initialDispositionState);
    }

    @Action(AssignOrderToSurveyorBusy)
    assignOrderToSurveyorBusy(ctx: StateContext<DispositionStateModel>, action: AssignOrderToSurveyorBusy) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            isAssigning: action.isBusy,
        });
    }

    @Action(OfferOrder)
    offerOrder(ctx: StateContext<DispositionStateModel>) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            isAssigning: true,
        });
    }

    @Action(OfferOrderSuccess)
    offerOrderSuccess(ctx: StateContext<DispositionStateModel>) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            isAssigning: false,
            orderId: null,
        });
    }
}
